import React, { useState } from 'react'
import CustomRadio from '../../components/UI/radio/CustomRadio';
import { setErrorButton } from '../../store/buttonSlice';
import { useDispatch } from 'react-redux';

export default function ProductivityContent({ checkboxes, setCheckboxes, error, setDisabled, setError, setValue }) {

    const dispatch = useDispatch();
    const [selectedOption, setSelectedOption] = useState(null);

    const handleCheckboxChange = (checkboxId, isChecked) => {

        setCheckboxes(prevCheckboxes => {
            const updatedCheckboxes = prevCheckboxes.map(checkbox =>
                checkbox.id === checkboxId ? { ...checkbox, checked: isChecked } : checkbox
            );

            const anyChecked = updatedCheckboxes.some(checkbox => checkbox.checked);
            setDisabled(!anyChecked);
            dispatch(setErrorButton(false))
            setError(false)
            return updatedCheckboxes;
        });
    };



    return (

        <>
            {checkboxes && checkboxes.map((checkbox, index) => (
                <div
                    key={checkbox.id}
                    checked={checkbox.checked}
                    onClick={() => handleCheckboxChange(checkbox.id, !checkbox.checked)}

                    className={`productivity-goals-item ${checkbox.checked ? 'checked' : undefined}`}
                >
                    <div className={`productivity-goals-item__checked ${error ? 'error' : ""} ${checkbox.checked ? 'checked' : ""}`}>
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.30859 6.00764L4.8727 8.31534L10.0009 3.69995" stroke="white" stroke-width="1.6" stroke-linecap="round" />
                        </svg>
                    </div>
                    <div>

                        <p>{checkbox.text}</p>
                    </div>
                </div>
            ))}
        </>
    )
}
